function handleTextBlockTabClick(clickedTab) {
  // Find the parent container
  const parentContainer = clickedTab.closest(
    ".c-collapsibleTextBlock__content_tabsBody"
  );
  if (!parentContainer) return;

  // Get all tabs and contents within this specific container
  const text_tabs = parentContainer.querySelectorAll(
    ".c-collapsibleTextBlock__tab"
  );
  const text_tabContents = parentContainer.querySelectorAll(
    ".c-collapsibleTextBlock__tabContent"
  );

  // Remove active class from all tabs and contents
  text_tabs.forEach((t) => t.classList.remove("active"));
  text_tabContents.forEach((content) => content.classList.remove("active"));

  // Add active class to clicked tab
  clickedTab.classList.add("active");

  // Get target content and activate it
  const targetId = clickedTab.getAttribute("data-target");

  const targetContent = parentContainer.querySelector(`#${targetId}`);
  if (targetContent) {
    targetContent.classList.add("active");
  }
}
